import React, { useState } from "react";
import Table from "./Table";
import AddCountry from "./AddCountry";
import "./style.css";
import MessageProvider from "./Context";

const Countries = () => {
    const [isWaiting, setIsWaiting] = useState(false);
    const [regiondata, setRegiondata] = useState(false);
    return (
        <div className="container py-5">
            {isWaiting && <div className="ca-overlay"></div>}
            <MessageProvider>
                <AddCountry regiondata={regiondata}/>
                <Table setIsWaiting={setIsWaiting} setRegiondata={setRegiondata}/>
            </MessageProvider>
        </div>
    );
};

export default Countries;
